import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CardContent,
  Card,
  Modal,
  Box,
  Paper,
  Dialog,
  CircularProgress,
  TablePagination,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import HRNavbar from "../../../HR/HRNavbar";
import MedicalForm from "./MedicalForm";
import DescriptionIcon from "@mui/icons-material/Description"; // example form icon
import { API_URL } from "../../../Config/api";

const HospitalCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  marginRight: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "43px",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",
  "&:hover": {
    backgroundColor: "#F7F7F7",
    cursor: "pointer",
  },
  fontWeight: "200",
});

const LongTearmForm = ({}) => {
  const [open, setOpen] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [eventId, setEventId] = useState(null);
  const [searchText, setSearchText] = useState(""); 





  const filteredData = tableData.filter((row) => {
    const search = searchText.toLowerCase();
    return (
      row.patient_name.toLowerCase().includes(search) ||
      row.patient_phone.toString().includes(search) ||
      row.caller_phone.toString().includes(search)
    );
  });


const paginatedData = filteredData.slice(
  page * rowsPerPage,
  page * rowsPerPage + rowsPerPage
);


  useEffect(() => {
  setPage(0);
}, [searchText]);

  console.log("TableData:", tableData);
  useEffect(() => {
  console.log("Dialog opened for eventId:", eventId);
}, [eventId]);

  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");

  const handleOpen = (id) => {
    setEventId(id); // dynamically set eventId
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEventId(null); // reset after close (optional)
  };
  const fetchFormData = async () => {
    try {
      setLoading(true); // start loader
      const response = await fetch(`${API_URL}/web/form/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      console.log("API Response:", data);
      setTableData(data.data || []);
    } catch (error) {
      console.error("Error fetching form data:", error);
    } finally {
      setLoading(false); // stop loader
    }
  };

  useEffect(() => {
    fetchFormData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };




  return (
    <div>
      <HRNavbar />
      <Box sx={{ flexGrow: 1, ml: 1, mr: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2, // spacing between text and input
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "600", fontSize: "18px", fontFamily: "Roboto" }}
          >
            Long Term Form
          </Typography>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search by Patient Name"
            sx={{ width: "300px" }}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <HospitalCard
                  style={{
                    background: "#A5D6A7",
                    color: "#000000ff",
                    borderRadius: "8px 10px 0 0",
                    height: "3rem",
                  }}
                >
                  <CardContent
                    style={{ flex: 0.7, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr. No</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Event Code</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Patient Name</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Patient Number</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Caller Number</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3.2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Services</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Authorised Name</Typography>
                  </CardContent>
                  {/* <CardContent
                  style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                >
                  <Typography variant="subtitle2">Name</Typography>
                </CardContent> */}
                  <CardContent style={{ flex: 1.2 }}>
                    <Typography variant="subtitle2">Action</Typography>
                  </CardContent>
                </HospitalCard>
              </TableRow>
            </TableHead>

          <TableBody>
  {loading ? (
    <TableRow>
      <TableCell colSpan={7} align="center">
        <CircularProgress />
      </TableCell>
    </TableRow>
  ) : filteredData.length > 0 ? (
    paginatedData.map((row, index) => (
      <TableRow key={row.event_id || index}>
        <HospitalCard>
          <CardContent style={{ flex: 0.7 }}>
            <Typography variant="subtitle2">
              {page * rowsPerPage + index + 1}
            </Typography>
          </CardContent>

          <CardContent style={{ flex: 2 }}>
            <Typography variant="subtitle2">
              {row.event_code}
            </Typography>
          </CardContent>

          <CardContent style={{ flex: 2.5 }}>
            <Typography variant="subtitle2">
              {row.patient_name}
            </Typography>
          </CardContent>

          <CardContent style={{ flex: 2 }}>
            <Typography variant="subtitle2">
              {row.patient_phone}
            </Typography>
          </CardContent>

          <CardContent style={{ flex: 2 }}>
            <Typography variant="subtitle2">
              {row.caller_phone}
            </Typography>
          </CardContent>

          <CardContent style={{ flex: 3.2 }}>
            <Typography variant="subtitle2">
              {row.services}
            </Typography>
          </CardContent>

          <CardContent style={{ flex: 2 }}>
            <Typography variant="subtitle2">
              {row.notify_name || "-"}
            </Typography>
          </CardContent>

          <CardContent
            style={{ flex: 1.2 }}
            onClick={() => handleOpen(row.event_id)}
          >
            <DescriptionIcon sx={{ color: "#000000", cursor: "pointer" }} />
          </CardContent>
        </HospitalCard>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={7} align="center">
        No Data Available
      </TableCell>
    </TableRow>
  )}
</TableBody>
          </Table>
        </TableContainer>
      </Box>

      <TablePagination
      sx={{  overflowY: "hidden" }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

     <Dialog
  open={open}
  onClose={() => setOpen(false)}
  fullWidth
  maxWidth={false}   
  PaperProps={{
    sx: {
    width: "95vw",
    height: "90vh",
    maxHeight: "90vh",
    overflow: "hidden", // correct
    borderRadius: 2,
  },
  }}
>
  {eventId && (
    <MedicalForm
      handleClose={handleClose}
      eventId={eventId}
      onClose={() => setOpen(false)}
      open={open}
      setOpen={setOpen}
     
      fetchFormData={fetchFormData}
    />
  )}
</Dialog>

    </div>
  );
};

export default LongTearmForm;
